export const PRESET_MESSAGES_ROW1 = [
  { text: "Submit shopping receipt for Skywards miles", type: "chat" },
  { text: "Any fun events today?", type: "wa" },
  { text: "Where is Zara?", type: "chat" },
  { text: "Help find my car", type: "wa" },
  { text: "Which parking for Waitrose?", type: "chat" },
  { text: "Whare to buy sports shoes?", type: "chat" },
  { text: "Lost wallet near atrium, connect security", type: "call" },
  { text: "Upload receipt for Skywards, sending photo", type: "chat" },
  { text: "Quiet cafe to work for 1 hour?", type: "talk" },
  { text: "Any live shows or pop-up experiences this evening?", type: "call" },
  { text: "Find a romantic dinner spot with fountain view", type: "chat" },
  {
    text: "Where can I buy birthday decor and balloons?",
    type: "wa",
  },
  { text: "Create a day plan for teens in the mall", type: "chat" },
];

export const PRESET_MESSAGES_ROW2 = [
  { text: "Check parking spots near cinema now?", type: "chat" },
  { text: "What fun activities for kids today?", type: "call" },
  { text: "Best parking for food court, directions?", type: "wa" },
  { text: "How far is Sephora from Zara?", type: "chat" },
  { text: "Recommend vegetarian place?", type: "chat" },
  {
    text: "We are fam of 5, need plan for shopping day, dinner and ice skating",
    type: "wa",
  },
  { text: "Find pharmacy near Starbucks, directions?", type: "chat" },
  { text: "Help finding parked car, have parking photo", type: "wa" },
  { text: "Park for cinema, where's closest lot?", type: "talk" },
  { text: "Best parking for McDonals Zabeel, available spaces?", type: "chat" },
  { text: "Which stores have best sneakers?", type: "wa" },
  { text: "Need quick gifts", type: "chat" },
];
